import { SubCategory2Enum, TypeActifEnum } from '@lib/models/generated/graphql';

export const actifTypeLabel: Record<TypeActifEnum, string> = {
  // Immo jouissance
  [TypeActifEnum.ResidencePrincipale]: 'Résidence principale',
  [TypeActifEnum.ResidenceSecondaire]: 'Résidence secondaire',

  // Immo locatif
  [TypeActifEnum.Classique]: 'Classique',
  [TypeActifEnum.Pinel]: 'Pinel',
  [TypeActifEnum.Duflot]: 'Duflot',
  [TypeActifEnum.Scellier]: 'Scellier',
  [TypeActifEnum.Robien]: 'Robien',
  [TypeActifEnum.Borloo]: 'Borloo',
  [TypeActifEnum.Besson]: 'Besson',
  [TypeActifEnum.Perissol]: 'Périssol',
  [TypeActifEnum.LmnpClassique]: 'LMNP Classique',
  [TypeActifEnum.LmnpCensi]: 'LMNP Censi-Bouvard',
  [TypeActifEnum.Lmp]: 'LMP',
  [TypeActifEnum.DemembrementTemporaire]: 'Démembrement temporaire',
  [TypeActifEnum.Malraux]: 'Malraux',
  [TypeActifEnum.MonumentHistorique]: 'Monument historique',
  [TypeActifEnum.Girardin]: 'Girardin',
  [TypeActifEnum.LoiJego]: 'Loi Jego',
  [TypeActifEnum.SecteurTouristique]: 'Secteur touristique',
  [TypeActifEnum.Opci]: 'OPCI',
  [TypeActifEnum.Scpi]: 'SCPI',

  // Foncier
  [TypeActifEnum.TerrainABatir]: 'Terrain à bâtir',
  [TypeActifEnum.TerreAgricole]: 'Terre agricole',
  [TypeActifEnum.BienRuralBailALongTerme]: 'Bien rural - bail à long terme',
  [TypeActifEnum.BoisEtPartsDeGff]: 'Bois & parts de GFF',
  [TypeActifEnum.PartsDeGfa]: 'Parts de GFA',
  [TypeActifEnum.PartsGfv]: 'Parts GFV',
  [TypeActifEnum.TerrainDAgrement]: "Terrain d'agrément",
  [TypeActifEnum.ScIouSarlDeFamille]: 'SCI ou SARL de famille',
  [TypeActifEnum.AutreFoncierNonBati]: 'Autre foncier non bâti',

  // Épargne bancaire
  [TypeActifEnum.LivretA]: 'Livret A',
  [TypeActifEnum.CompteCourant]: 'Compte courant',
  [TypeActifEnum.LivretClassique]: 'Livret classique',
  [TypeActifEnum.LivretBleu]: 'Livret Bleu',
  [TypeActifEnum.Ldd]: 'LDD',
  [TypeActifEnum.Lep]: 'LEP',
  [TypeActifEnum.Cel]: 'CEL',
  [TypeActifEnum.LivretJeune]: 'Livret jeune',
  [TypeActifEnum.Cat]: 'CAT',
  [TypeActifEnum.AutreLiquidite]: 'Autre liquidité',
  [TypeActifEnum.Pel]: 'PEL',

  // Épargne financière
  [TypeActifEnum.AssuranceVie]: 'Assurance vie',
  [TypeActifEnum.ContratDeCapitalisation]: 'Contrat de capitalisation',
  [TypeActifEnum.PepBancaire]: 'PEP bancaire',
  [TypeActifEnum.PepAssuranceVie]: 'PEP Assurance Vie',
  [TypeActifEnum.CompteTitresCto]: 'Compte titres (CTO)',
  [TypeActifEnum.AssuranceVieApbDifferee]: 'Assurance vie à PB différée',
  [TypeActifEnum.AutreValeurMobilier]: 'Autre valeur mobilière',
  [TypeActifEnum.AutreEpargne]: 'Autre épargne',
  [TypeActifEnum.Pea]: 'PEA',
  [TypeActifEnum.Peapme]: 'PEA PME',

  // Diversification
  [TypeActifEnum.CapitalRisque]: 'Capital Risque',
  [TypeActifEnum.Fip]: 'FIP',
  [TypeActifEnum.FipCorse]: 'FIP Corse',
  [TypeActifEnum.Fcpi]: 'FCPI',
  [TypeActifEnum.Pme]: 'PME',
  [TypeActifEnum.Sofica]: 'Sofica',
  [TypeActifEnum.Fcpr]: 'FCPR',
  [TypeActifEnum.Holding]: 'Holding',
  [TypeActifEnum.AutresTitresNonCotes]: 'Autres titres non côtés',
  [TypeActifEnum.FipOutreMer]: 'FIP outre mer',

  // Autres financier
  [TypeActifEnum.ContratTontinier]: 'Contrat tontinier',

  // Épargne retraite
  [TypeActifEnum.Perp]: 'PERP',
  [TypeActifEnum.Pee]: 'PEE',
  [TypeActifEnum.Perco]: 'PERCO',
  [TypeActifEnum.Article82]: 'Article 82',
  [TypeActifEnum.Article83]: 'Article 83',
  [TypeActifEnum.Article39]: 'Article 39',
  [TypeActifEnum.Madelin]: 'Madelin ',
  [TypeActifEnum.Participation]: 'Participation',
  [TypeActifEnum.RenteUniverselle]: 'Rente universelle',
  [TypeActifEnum.EpargnePension]: 'Epargne pension',
  [TypeActifEnum.Eip]: 'EIP',
  [TypeActifEnum.Plci]: 'PLCI',
  [TypeActifEnum.Cpti]: 'CPTI',
  [TypeActifEnum.Elt]: 'ELT',
  [TypeActifEnum.Per]: 'PER',
  [TypeActifEnum.Prefon]: 'Préfon',
  [TypeActifEnum.Inami]: 'Inami',

  // Biens professionnels
  [TypeActifEnum.PartsDeSociete]: 'Parts de société',
  [TypeActifEnum.BienImmobilier]: 'Bien immobilier',
  [TypeActifEnum.FondsDeCommerce]: 'Fonds de commerce',
  [TypeActifEnum.ClienteleCivile]: 'Clientèle civile',
  [TypeActifEnum.MaterielProfessionnel]: 'Matériel professionnel',
  [TypeActifEnum.VehiculeProfessionnel]: 'Véhicule professionnel',

  // Autres biens meubles
  [TypeActifEnum.Meuble]: 'Meuble',
  [TypeActifEnum.Bijoux]: 'Bijoux',
  [TypeActifEnum.Vehicules]: 'Véhicules',
  [TypeActifEnum.ObjetDArtAntiquiteCollection]: "Objet d'art/antiquité/collection",
  [TypeActifEnum.MetauxPrecieux]: 'Métaux précieux',
  [TypeActifEnum.AutrePlacement]: 'Autre placement',
  [TypeActifEnum.Creance]: 'Créance',
};

export const passifTypeLabel: Record<string, string> = {
  [SubCategory2Enum.CreditImmo]: 'Crédit immobilier',
  [SubCategory2Enum.CreditConso]: 'Crédit conso ou crédit revolving',
  [SubCategory2Enum.AutreCredit]: 'Autre crédit',
  [SubCategory2Enum.Dettes]: 'Dette fiscale',
  [SubCategory2Enum.Avance]: 'Avance',
};
